export type Suggestion = {
  suggestion: string,
  prefix: string,
  truncatedPrefix: string
}

function truncateLeft (str: string, maxLength: number) : string {
  if (str.length <= maxLength) {
    return str
  }
  const startIndex = str.length - maxLength
  return '…' + str.substring(startIndex)
}

export function useTypeahead (query: Ref<string>, ref: string) : Ref<Suggestion[]|null> {
  const { data } = useLazyAsyncData(ref, async () => {
    if (!query.value?.length || query.value.length < 3 || query.value.endsWith(' ')) {
      return []
    }
    const queryWords = query.value.toLowerCase().split(' ')
    const autocompleteQuery = queryWords[queryWords.length - 1]
    const truncatedPrefix = truncateLeft(query.value, 30)
    const result = await fetchFromSearchHost<string[]>('/typeahead', {
      method: 'POST',
      body: {
        q: autocompleteQuery
      }
    })
    return result.map(suggestion => suggestion.replace(autocompleteQuery, '')).filter(suggestion => suggestion.length).map(suggestion => ({ suggestion, prefix: query.value, truncatedPrefix }))
  }, { watch: [query], immediate: false })

  return data
}
